angular.module('elfium').service('dashboardTotalService', ['$q', 'businessCaseService', 'taskSplitByTypeFilter', 'TASK_TYPES', 'TASK_STATES',
    function ($q, businessCaseService, taskSplitByTypeFilter, TASK_TYPES, TASK_STATES) {
        var that = this;
        that.getBusinessCaseCounterDto = function (dashboardFilter) {
            var deferred = $q.defer();
            businessCaseService.getBusinessCasesWithTasks().then(function (businessCases) {
                deferred.resolve(that._buildCounter(businessCases));
            }, deferred.reject);
            return deferred.promise;
        };
        that._buildCounter = function (businessCases) {
            return that._fillCounter(businessCases, {
                total: 0,
                active: 0,
                new_: 0,
                hr: 0,
                elf: 0,
                als: 0,
                eu: 0
            });
        };
        that._fillCounter = function (businessCases, counter) {
            angular.forEach(businessCases, function (businessCase) {
                counter.total++;
                if (that._hasActiveTasks(businessCase.tasks)) {
                    counter.active++;
                }
                if (that._hasNewTasks(businessCase.tasks)) {
                    counter.new_++;
                }
                switch (businessCase.divize) {
                    case 'ELF':
                        counter.elf++
                        break;
                    case 'HR':
                        counter.hr++;
                        break;
                    case 'ALS':
                        counter.als++;
                        break;
                    case 'EU I':
                    case 'EU VZ':
                        counter.eu++;
                        break;
                }
            });
            return counter;
        };
        that._hasActiveTasks = function (tasks) {
            var hasActiveTasks = false;
            for (var i = 0; i < tasks.length; ++i) {
                if (tasks[i].stav == TASK_STATES.NAPLANOVANO) {
                    hasActiveTasks = true;
                    break;
                }
            }
            return hasActiveTasks;
        };
        that._hasNewTasks = function (tasks) {
            var tasksByType = taskSplitByTypeFilter(tasks);
            return tasksByType[TASK_TYPES.POTREBA] && tasksByType[TASK_TYPES.POTREBA].length > 0 && (!tasksByType[TASK_TYPES.NABIDKA] || tasksByType[TASK_TYPES.NABIDKA].length == 0);
        };
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboardTotalService.ts